export const initializeGtm = (
    globalWindow: Window,
    doc: Document,
    tagName: string,
    dataLayerName: string,
    containerId: string
) => {
    const gtmAuth = globalWindow.APP_CONFIG.GTM_AUTH
    const gtmPreview = globalWindow.APP_CONFIG.GTM_PREVIEW
    let urlExtension = gtmAuth ? '&gtm_auth=' + gtmAuth : ''
    urlExtension += gtmPreview ? '&gtm_preview=' + gtmPreview + '&gtm_cookies_win=x' : ''
    const nonce = doc.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content
    const gtmBootstrap = doc.createElement('script')
    if (nonce) {
        gtmBootstrap.setAttribute('nonce', nonce)
    }
    gtmBootstrap.textContent = `(function(w,d,s,l,i,e){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+e;var n=d.querySelector('[nonce]');
n&&j.setAttribute('nonce',n.nonce||n.getAttribute('nonce'));f.parentNode.insertBefore(j,f);
})(window,document,${JSON.stringify(tagName)},${JSON.stringify(dataLayerName)},${JSON.stringify(containerId)},${JSON.stringify(urlExtension)});`
    const firstScript = doc.getElementsByTagName(tagName)[0]
    firstScript.parentNode!.insertBefore(gtmBootstrap, firstScript)
}
